import React from 'react';
import PropTypes from 'prop-types';

const BeaconStateContext = React.createContext(undefined);
const BeaconDispatchContext = React.createContext(undefined);

function init() {
  return {};
}

function reducer(state, action) {
  switch (action.type) {
    case 'setBeaconCount': {
      return {
        ...state,
        [action.beacon]: action.count,
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}
function BeaconProvider({ children, initialState }) {
  const [state, dispatch] = React.useReducer(reducer, initialState, init);

  return (
    <BeaconStateContext.Provider value={state}>
      <BeaconDispatchContext.Provider value={dispatch}>
        {children}
      </BeaconDispatchContext.Provider>
    </BeaconStateContext.Provider>
  );
}

function useBeaconState() {
  const context = React.useContext(BeaconStateContext);

  if (context === undefined) {
    throw new Error('useBeaconState must be used within a BeaconProvider');
  }

  return context;
}

function useBeaconDispatch() {
  const context = React.useContext(BeaconDispatchContext);

  if (context === undefined) {
    throw new Error('useBeaconDispatch must be used within a BeaconProvider');
  }

  return context;
}

BeaconProvider.defaultProps = {
  initialState: {},
};

BeaconProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  initialState: PropTypes.object,
};

export {
  BeaconProvider,
  useBeaconState,
  useBeaconDispatch,
};
